import angular from 'angular';
import 'angular-ui-router';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import HeaderGamesModule from './header-games';
import HeaderGameDevelopersModule from './header-game-developers';
import HeaderCampaignsModule from './header-campaigns';
import HeaderSegmentsModule from './header-segments';
import HeaderTimeframeModule from './header-timeframe';

export function HeaderComponent() {
  return {
    template: `<div class="o-layout-primary__header" ng-transclude></div>`,
    restrict: 'E',
    replace: true,
    transclude: true
  };
};

export function HeaderPrimaryComponent() {
  return {
    template: `<div class="c-header-primary" ng-transclude></div>`,
    restrict: 'E',
    replace: true,
    transclude: true
  };
};

export function HeaderSecondaryComponent() {
  return {
    template: `<div class="c-header-secondary" ng-transclude></div>`,
    restrict: 'E',
    replace: true,
    transclude: true
  };
};

export function HeaderElementComponent() {
  return {
    template: `<div class="u-pv- u-ph" ng-transclude></div>`,
    restrict: 'E',
    replace: true,
    transclude: true
  };
};

export function HeaderTitleComponent() {
  return {
    template: `<h2 class="c-header-primary__item c-header-primary__item--fill c-header-primary__title" ng-transclude></h2>`,
    restrict: 'E',
    replace: true,
    transclude: true
  };
};

export default angular.module('header', [
  'ui.router',
  ServicesModule.name,
  ResourcesModule.name,
  HeaderGamesModule.name,
  HeaderGameDevelopersModule.name,
  HeaderCampaignsModule.name,
  HeaderSegmentsModule.name,
  HeaderTimeframeModule.name
])
.directive('header', HeaderComponent)
.directive('headerPrimary', HeaderPrimaryComponent)
.directive('headerSecondary', HeaderSecondaryComponent)
.directive('headerElement', HeaderElementComponent)
.directive('headerTitle', HeaderTitleComponent)


/** WEBPACK FOOTER **
 ** ./src/common/header/header.js
 **/